import * as Types from './CreateButton.d';
import CreateButton, { CreateButton as NotPureCreateButton } from './CreateButton';
import { StyledCreateButton, Content, Stretcher, Border } from './CreateButton.styled';

export { NotPureCreateButton as CreateButton, StyledCreateButton, Content, Stretcher, Border };
export type CreateButtonProps = Types.CreateButtonProps;
export default CreateButton;
